import { CHECKOUT_PARAMS } from '../constants/checkoutParams'

/**
 * Read from `window.location` on purpose, not from the router query: the success params are dropped
 * with `stripQueryParams`, which goes through the unpatched `History.prototype.replaceState` and so
 * never reaches the router's query. The real URL does change, so this answers correctly both while
 * the return is being processed and after the dialog has cleaned up.
 */
export const hasPurchaseReturnInUrl = (): boolean => {
    if (typeof window === 'undefined') {
        return false
    }

    const params = new URLSearchParams(window.location.search)

    return (
        params.get(CHECKOUT_PARAMS.success) === 'true' ||
        params.get(CHECKOUT_PARAMS.audacitySuccess) === 'true'
    )
}
